var _a;
import * as React from 'react';
import { createSvgIcon, IconDirectionality } from '..';
export var Close = createSvgIcon((_a = {},
    _a[IconDirectionality.LeftToRight] = (React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "10", strokeWidth: "2", d: "M5 5l14 14M19 5L5 19" })),
    _a));
//# sourceMappingURL=Close.js.map